import React from 'react';
import './tables.css';

/* Generic DataTable Component */
export default function DataTable({ columns = [], data = [], filters = {}, onFilterChange, getRowStyle, stickyHeader = true, separateFilters = false, onRowClick }) {
  const handleFilterChange = (key, value) => {
    if (!onFilterChange) return;
    onFilterChange(prev => ({ ...prev, [key]: value }));
  };

  const headerStyleBase = { background: '#fff', top: 0, zIndex: 5 };

  const renderFilterInput = (col) => (
    col.filterRender ? (
      col.filterRender({ value: filters[col.filterKey] || '', onChange: v => handleFilterChange(col.filterKey, v) })
    ) : (
      <input
        style={{ width: '100%', boxSizing: 'border-box', padding: '2px 4px' }}
        type="text"
        value={filters[col.filterKey] || ''}
        placeholder="Filter"
        onChange={e => handleFilterChange(col.filterKey, e.target.value)}
      />
    )
  );

  return (
    <>
      {separateFilters && (
        <div style={{ display: 'grid', gridTemplateColumns: columns.map(c => c.width || '1fr').join(' ') , gap: 8, marginBottom: 8 }}>
          {columns.map(col => (
            <div key={`filter-${col.key}`}>{col.filterKey ? renderFilterInput(col) : null}</div>
          ))}
        </div>
      )}
      <div className="responsive-table-wrapper">
        <table className="data-table" cellPadding={6} style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'auto' }}>
          <thead>
            <tr>
              {columns.map(col => {
                const thStyle = {
                  width: col.width || 'auto',
                  ...(stickyHeader && { position: 'sticky', ...headerStyleBase }),
                  ...col.thStyle
                };
                return (
                  <th key={col.key} style={thStyle}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <span>{col.header}</span>
                      {!separateFilters && col.filterKey && renderFilterInput(col)}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr
                key={i}
                style={{ ...(getRowStyle ? getRowStyle(row) : undefined), ...(onRowClick ? { cursor: 'pointer' } : {}) }}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
              >
                {columns.map(col => (
                  <td key={col.key + '-' + i} style={col.tdStyle}>
                    {col.render ? col.render(row) : (col.accessor ? col.accessor(row) : row[col.key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
